import { useEffect, useRef } from 'react';

export function usePrevious<T>(newValue: T): T | undefined {
  const previousRef = useRef<T>();

  useEffect(() => {
    previousRef.current = newValue;
  });

  return previousRef.current;
}
